import { useOrderIdCtx } from '@contexts/OrderContext/OrderProvider'
import { ValidateOrderStatus } from '@contexts/ValidateOrderStatus/ValidateOrderStatus'
import { Redirect } from '@segments/Routing/client'
import * as React from 'react'

import {
  AgreementProvider,
  FormAvailablePaymentMethodsProvider,
  FormOrderProvider,
  useLoadFormOrder,
} from '~shared/segments/FormScreen'

import { FormScreenResponsiveContent } from './components/FormScreenResponsiveContent'
import { FormCartContentProvider } from './contexts/FormCartContentProvider'
import { FormPersistenceProvider } from './contexts/FormPersistenceProvider'
import { FormProvider } from './contexts/FormProvider'

type TProps = NoChildren

/**
 * The main screen for the form wizard.
 */
export const FormScreen: React.FC<TProps> = () => {
  const order = useLoadFormOrder()
  const { orderId, isLoadingPersistence } = useOrderIdCtx() // TODO move into the CartContentProvider?

  if (isLoadingPersistence) {
    return null
  }

  if (!orderId) {
    return <Redirect to={`home`} />
  }

  return (
    <FormOrderProvider order={order}>
      <FormCartContentProvider>
        <FormAvailablePaymentMethodsProvider>
          <FormPersistenceProvider>
            <FormProvider>
              <AgreementProvider>
                <ValidateOrderStatus />

                <FormScreenResponsiveContent />
              </AgreementProvider>
            </FormProvider>
          </FormPersistenceProvider>
        </FormAvailablePaymentMethodsProvider>
      </FormCartContentProvider>
    </FormOrderProvider>
  )
}
